import React from 'react';
import { Link } from 'react-router-dom';
import './ServicesPage.css';

const ServicesPage = () => {
  const serviceCategories = [
    {
      id: 'orthodontics',
      title: 'Orthodontics',
      subtitle: 'Straighten Your Teeth with Expert Care',
      description: 'Professional orthodontic treatments to correct misaligned teeth and improve your bite for a perfect smile.',
      image: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      color: '#007bbf',
      treatments: [
        {
          name: 'Braces',
          description: 'Traditional and modern braces for comprehensive teeth straightening',
          duration: '18-24 months',
          price: 'Starting from PKR 80,000'
        }
      ]
    },
    {
      id: 'implants',
      title: 'Implants',
      subtitle: 'Permanent Tooth Replacement Solutions',
      description: 'Advanced implant dentistry including placement, repairs, and supporting procedures for lasting results.',
      image: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      color: '#28a745',
      treatments: [
        {
          name: 'Dental Implants',
          description: 'Permanent tooth replacement with titanium implants',
          duration: '3-6 months',
          price: 'Starting from PKR 60,000'
        },
        {
          name: 'Implant Repairs',
          description: 'Professional repair and maintenance of existing implants',
          duration: '1-2 visits',
          price: 'Starting from PKR 15,000'
        },
        {
          name: 'Bone Graft & Sinus Lift',
          description: 'Artificial bone grafting and maxillary sinus lift procedures',
          duration: '2-4 visits',
          price: 'Starting from PKR 25,000'
        }
      ]
    },
    {
      id: 'cosmetic',
      title: 'Cosmetic Dentistry',
      subtitle: 'Enhance Your Natural Beauty',
      description: 'Comprehensive cosmetic treatments to improve the appearance and function of your teeth.',
      image: 'https://images.unsplash.com/photo-1609207825181-52d3214556dd?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      color: '#17a2b8',
      treatments: [
        {
          name: 'Cosmetic Treatments',
          description: 'Complete smile makeovers and aesthetic improvements',
          duration: '2-4 visits',
          price: 'Starting from PKR 20,000'
        },
        {
          name: 'Composite Restoration',
          description: 'Tooth-colored fillings and restorations for natural appearance',
          duration: '1-2 visits',
          price: 'Starting from PKR 3,000'
        },
        {
          name: 'PFM & Zirconia Crowns',
          description: 'High-quality porcelain-fused-metal and zirconia crowns',
          duration: '2-3 visits',
          price: 'Starting from PKR 12,000'
        },
        {
          name: 'Partial & Complete Dentures',
          description: 'Custom-made dentures for missing teeth replacement',
          duration: '4-6 weeks',
          price: 'Starting from PKR 25,000'
        }
      ]
    },
    {
      id: 'restorative',
      title: 'Restorative Dentistry',
      subtitle: 'Restore Function and Health',
      description: 'Advanced restorative treatments to save and repair damaged teeth and restore oral health.',
      image: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      color: '#dc3545',
      treatments: [
        {
          name: 'Root Canal Treatment (RCT)',
          description: 'Advanced endodontic treatment to save infected teeth',
          duration: '2-3 visits',
          price: 'Starting from PKR 12,000'
        },
        {
          name: 'Simple & Surgical Extractions',
          description: 'Professional tooth extractions with minimal discomfort',
          duration: '1 visit',
          price: 'Starting from PKR 3,000'
        },
        {
          name: 'Impactions & Apicectomies',
          description: 'Surgical removal of impacted teeth and root-end surgeries',
          duration: '1-2 visits',
          price: 'Starting from PKR 8,000'
        }
      ]
    }
  ];

  const additionalServices = [
    {
      name: 'Periodontics (Gum Treatment)',
      description: 'Scaling and Root Planning (SRP) for gum disease treatment',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
        </svg>
      )
    },
    {
      name: 'Oral & Maxillofacial Surgery',
      description: 'Soft tissue surgeries, tongue tie treatment, biopsies, mole and wart removal',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V5H19V19Z"/>
        </svg>
      )
    },
    {
      name: 'TMJ & Jaw Disorders',
      description: 'Specialized treatment for temporomandibular joint disorders and jaw pain',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
        </svg>
      )
    },
    {
      name: 'Anesthesia & Sedation Services',
      description: 'Conscious sedation and anesthesiologist services for comfortable treatment',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
        </svg>
      )
    }
  ];

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-badge">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
            </svg>
            Complete Dental Care
          </div>
          <h1 className="hero-title">Prime Care Dental Services</h1>
          <p className="hero-subtitle">
            Comprehensive dental care services including orthodontics, implants, cosmetic dentistry, and specialized treatments
          </p>
          <p className="hero-description">
                         Dr. Muhammad Junaid and our experienced team provide a complete range of dental services from routine care 
            to complex surgical procedures, using the latest technology and techniques to ensure optimal outcomes.
          </p>
          <div className="hero-stats">
            <div className="stat-item">
              <span className="stat-number">10+</span>
              <span className="stat-label">Years Experience</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">1000+</span>
              <span className="stat-label">Happy Patients</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">20+</span>
              <span className="stat-label">Services Offered</span>
            </div>
          </div>
        </div>
      </section>

      <div className="page-wrapper">
        {/* Main Services Categories */}
        <section className="main-services">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Our Main Service Categories</h2>
              <p className="section-description">
                We specialize in four main areas of dental care, each designed to address specific needs and goals for comprehensive oral health.
              </p>
            </div>

            <div className="services-grid">
              {serviceCategories.map((category, index) => (
                <div key={category.id} className="service-category-card">
                  <div className="category-image">
                    <img src={category.image} alt={category.title} />
                    <div className="category-overlay" style={{ backgroundColor: `${category.color}99` }}>
                      <Link to={`/service/${category.id}`} className="view-details-btn">
                        View Details
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"/>
                        </svg>
                      </Link>
                    </div>
                  </div>
                  
                  <div className="category-content">
                    <div className="category-header">
                      <h3 className="category-title" style={{ color: category.color }}>
                        {category.title}
                      </h3>
                      <p className="category-subtitle">{category.subtitle}</p>
                      <p className="category-description">{category.description}</p>
                    </div>

                    <div className="treatments-list">
                      <h4>Available Treatments:</h4>
                      <ul>
                        {category.treatments.map((treatment, idx) => (
                          <li key={idx} className="treatment-item">
                            <div className="treatment-info">
                              <span className="treatment-name">{treatment.name}</span>
                              <span className="treatment-price">{treatment.price}</span>
                            </div>
                            <p className="treatment-desc">{treatment.description}</p>
                            <div className="treatment-meta">
                              <span className="treatment-duration">Duration: {treatment.duration}</span>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="category-actions">
                      <Link 
                        to={`/service/${category.id}`} 
                        className="learn-more-btn"
                        style={{ backgroundColor: category.color }}
                      >
                        Learn More
                      </Link>
                      <Link to="/contact" className="book-appointment-btn">
                        Book Appointment
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Additional Services */}
        <section className="additional-services">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Additional Services</h2>
              <p className="section-description">
                Beyond our main specialties, we offer additional dental services to meet all your oral health needs.
              </p>
            </div>

            <div className="additional-services-grid">
              {additionalServices.map((service, index) => (
                <div key={index} className="additional-service-card">
                  <div className="service-icon">
                    {service.icon}
                  </div>
                  <h4 className="service-name">{service.name}</h4>
                  <p className="service-description">{service.description}</p>
                  <Link to="/#contact" className="contact-btn">
                    Contact Us
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="why-choose-us">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Why Choose OrthoSmile?</h2>
            </div>

            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
                  </svg>
                </div>
                <h4>Expert Team</h4>
                <p>Our experienced dental professionals have 15+ years of combined expertise</p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
                  </svg>
                </div>
                <h4>Advanced Technology</h4>
                <p>State-of-the-art equipment and modern treatment techniques for optimal results</p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2M21 9V7L15 1H5C3.89 1 3 1.89 3 3V21C3 22.11 3.89 23 5 23H19C20.11 23 21 22.11 21 21V9M19 9H14V4H5V21H19V9Z"/>
                  </svg>
                </div>
                <h4>Personalized Care</h4>
                <p>Customized treatment plans tailored to your specific needs and goals</p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M19 19H5V8H19V19M7 10H12V15H7"/>
                  </svg>
                </div>
                <h4>Flexible Scheduling</h4>
                <p>Convenient appointment times that work with your busy schedule</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="services-cta">
          <div className="container">
            <div className="cta-content">
              <h2>Ready to Transform Your Smile?</h2>
              <p>
                Schedule a consultation today and let our expert team create a personalized treatment plan for you.
              </p>
              <div className="cta-actions">
                <Link to="/#contact" className="cta-primary">Book Consultation</Link>
                <a href="tel:+923212345678" className="cta-secondary">Call Now</a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ServicesPage; 